import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ClinicalNoteService } from '@service/clinicalnote.service';
import { DatePipe } from '@angular/common';
import { ClinicalNote, ClinicalNoteViewModel, ClinicalNoteMaster } from '@models/appointments/clinicalnote.model';
import { HttpBaseService } from '@service/http-base.service';
import * as _ from 'underscore';
import { CustomWarningDialogComponent } from '../../../../module/custom-warning-popup/custom-warning.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BeyondEMRHelper } from '../../../../helpers/beyondemr-helper';
import { BeyondEMRConstants } from '../../../../helpers/beyondemrconstants';
import { Router } from '@angular/router';
import { RoutingHelper } from '@helpers/routinghelper';
@Component({
  selector: 'app-patientnote',
  templateUrl: './patientnote.component.html',
  styleUrls: ['./patientnote.component.css']
})
export class PatientNoteDialogComponent {
  notes: ClinicalNote;
  noteId: number;
  noteType: string;
  selectedId: number;
  appointmentDate: string;
  confirmationType: string;
  apiURL: string;
  masters: ClinicalNoteMaster;
  canDelete: boolean = false;
  deleteURL: string;
  reportApiUrl: string;

  constructor(
    public dialogRef: MatDialogRef<PatientNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public clinicalNoteService: ClinicalNoteService,
    private datePipe: DatePipe,
    private httpService: HttpBaseService,
    private spinner: NgxSpinnerService,
    private dialog?: MatDialog,
    private helper?: BeyondEMRHelper,
    private router?: Router,
    private routingHelper?: RoutingHelper,
  ) {
    
    dialogRef.disableClose = true;
    this.noteId = data.NoteId;
    this.apiURL = data.APIUrl
    this.reportApiUrl = data.reportApiUrl
    this.getFormData();
    this.deleteURL = this.apiURL + `clinicalnote/Remove/`;
    }
    ngAfterViewInit() {
      this.httpService.getAPIURL().subscribe(url => {
        this.reportApiUrl = `${url.REPORT_API_URL}`;
      });
    }
  onNoClick(): void {
    this.dialogRef.close();
  }

  getFormData() {
    // let id = this.routingHelper.EncodeParam(this.noteId);
    this.httpService.get(this.apiURL + "clinicalnote/edit/" + this.noteId, null, true).subscribe(res => {
      if (res) {
        let data = res as ClinicalNoteViewModel;       
          data.Entity.AppointmentNotes = _.each(data.Entity.AppointmentNotes, function (x) {
            x.Notes = x.Notes.replace(/<a /g, "<span ");
            x.Notes = x.Notes.replace(/a>/g, "span>");
          })
        this.canDelete = (data.Entity.StatusId < BeyondEMRConstants.STATUS.Checked_Out);
        this.notes = data.Entity;
        this.masters = data.Masters;
        this.bindTemplateName();       
      }
    });
  }

  bindTemplateName() {
    let templateId = this.notes.AppointmentNotes?.length > 0 ? this.notes.AppointmentNotes[0].NotesTemplateId : 0;
    this.noteType = templateId > 0 ? this.masters.Templates.find(x => x.Id == templateId)?.DisplayName : 0;
    this.notes.AppointmentDate = this.datePipe.transform(this.notes.AppointmentDate, "MM/dd/yyyy");
  }

  onDelete() {
    const dialogRef = this.dialog.open(CustomWarningDialogComponent, {
      width: '400px',
      data: {
        header: "Are you sure?",
        body: "Do you want to Delete the Clinical note.",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result == true) {
        this.httpService.delete(this.deleteURL + this.noteId, null).subscribe(res => {
          this.spinner.hide();
          this.helper.showNotification("Clinical Note Deleted Successfully");
          this.dialogRef.close();
          this.router.navigate(['/dashboard/main']);
        });
      }
    });
  }
  onPrintNotes() {
    this.spinner.show();
    let url =this.reportApiUrl + 'evaluation/NotesDetailsReport/' + this.noteId;
    this.httpService.reportSearch( url, 'NotesReport.pdf', null, true).subscribe(res => {
      this.spinner.hide();
    });
  }
}
